import React from "react";

function AgesFiltersSkeleton() {
  return (
    <div className="flex justify-center overflow-x-auto gap-10 py-20 scroll">
      {[1, 2, 3, 4].map((filter) => (
        <div
          key={filter}
          className="h-9 bg-gray400 rounded-full w-20 mb-4"
        ></div>
      ))}
    </div>
  );
}

export default AgesFiltersSkeleton;
